"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// THE PATIENT AT A GLANCE: the strip at the top of the controller.
//
//   - one line that says what is happening to the patient now (in arrest, apnoeic and not being
//     ventilated, ventilated on the anaesthetic machine, stable ...), coloured by how urgent it is
//   - flags for the obs that are out of range (distressed, hypoxic, hypotensive, GCS ...), worked out
//     from the patient's TRUE obs, whether or not a sensor is on to show them to the team
//   - a stick figure showing what is attached: ECG leads, SpO2 probe, BP cuff, temperature, capnography,
//     arterial line, IV access, central line, airway, ventilator, pads, catheter, CPR
//   - the ventilator chooser (transport ventilator, ICU ventilator, anaesthetic machine), switchable at any time
//
// Everything is derived from the engine state the controller already has (only "Show on monitor"
// sends anything: the picture, in monitorPopup). The thresholds are NEWS2's red scores for adults and approximate ranges for children; they
// are prompts for the facilitator, not a scoring system.
(function () {
  var _React = React,
    useState = _React.useState;
  var has = function has(set, k) {
    return !!(set && typeof set.has === 'function' && set.has(k));
  };
  var num = function num(v) {
    return Number.isFinite(Number(v)) && v !== null && v !== '' ? Number(v) : null;
  };

  // Out-of-range limits by age (years). Adults: NEWS2 (RCP 2017) red scores. Children: approximate
  // limits from the usual paediatric ranges, wide enough to flag only clearly abnormal obs.
  function limitsFor(age) {
    var a = num(age);
    if (a !== null && a < 1) return {
      rrHi: 60,
      rrLo: 20,
      hrHi: 180,
      hrLo: 100,
      sbpLo: 70
    };
    if (a !== null && a < 5) return {
      rrHi: 40,
      rrLo: 15,
      hrHi: 160,
      hrLo: 80,
      sbpLo: 75
    };
    // NEWS2 is not validated under 16, so 12 to 15 year olds keep the older children's limits.
    if (a !== null && a < 16) return {
      rrHi: 30,
      rrLo: 12,
      hrHi: 140,
      hrLo: 60,
      sbpLo: 80
    };
    return {
      rrHi: 24,
      rrLo: 9,
      hrHi: 130,
      hrLo: 41,
      sbpLo: 91
    };
  }

  // What the patient's state is, worked out once and used by the strip, the figure and the tests.
  function assess(state) {
    var RG = window.RHYTHMS;
    var VP = window.VENT_PROFILES;
    var VE = window.VENT_ENGINE;
    var s = state || {};
    var v = s.vitals || {};
    var act = s.activeInterventions || new Set();
    var sensors = window.getSensors ? window.getSensors(s) : {};
    var rhythm = s.rhythm || 'Sinus Rhythm';
    var arrest = !!(RG && RG.isPulseless(rhythm));
    var age = s.scenario ? s.scenario.patientAge : null;
    var L = limitsFor(age);

    // Airway and breathing support.
    var tube = has(act, 'RSI') ? 'ett' : has(act, 'FONA') ? 'fona' : has(act, 'i-gel') ? 'sga' : null;
    var bagging = has(act, 'Bagging');
    var niv = has(act, 'NIV') ? 'NIV' : has(act, 'CPAP') ? 'CPAP' : null;
    var oxygen = has(act, 'Oxygen');
    var adjunct = has(act, 'OPA') ? 'OPA' : has(act, 'NPA') ? 'NPA' : null;

    // The ventilators linked to the session, and the one breathing for the patient (if any).
    var mirrors = Object.keys(s.ventMirror || {}).map(function (k) {
      return s.ventMirror[k];
    }).filter(Boolean).sort(function (a, b) {
      return Number(b.ts) - Number(a.ts);
    });
    var vent = mirrors[0] || null;
    // Counted as ventilating only when it reaches the patient: switched on, the facilitator's link
    // to the obs not turned off, and the circuit connected. Man/Spon on the anaesthetic machine ventilates only
    // when breaths are being given (the bag squeezed or the patient breathing), and high-flow
    // oxygen on the transport ventilator or C6 gives oxygen, not breaths.
    var ventMode = vent ? String(vent.mode || '') : '';
    var manual = ventMode === 'MAN',
      highFlow = ventMode === 'HiFlowO2';
    var unplugged = !!(vent && vent.phys && Number(vent.phys.conn) === 0);
    var reaches = !!(vent && vent.state === 'ventilating' && s.ventLink !== false && !unplugged);
    var manBreaths = !!(vent && vent.mon && Number(vent.mon.ftot) > 0);
    var ventilating = reaches && !highFlow && (!manual || manBreaths);
    var ventWhy = !vent ? '' : vent.state === 'standby' ? 'in standby' : vent.state === 'off' ? 'off' : vent.state !== 'ventilating' ? 'not ventilating' : s.ventLink === false ? 'not linked to the patient' : unplugged ? 'disconnected from the patient' : highFlow ? 'on high-flow oxygen' : manual ? 'in Man/Spon with no breaths being given' : 'not ventilating';
    var model = VP ? VP.modelOf(s.vent && s.vent.model) : 't1';
    var modelName = VP ? VP.MODEL_SHORT[model] : 'ventilator';
    var modelLabel = VP ? VP.MODELS[model] : 'Ventilator';
    var paralysed = !!s.isParalysed;
    var rr = num(v.rr),
      spo2 = num(v.spO2),
      hr = num(v.hr),
      sbp = num(v.bpSys),
      dbp = num(v.bpDia);
    var gcs = num(v.gcs),
      temp = num(v.temp),
      bm = num(v.bm);
    var supported = ventilating || bagging || !!niv;
    var ventName = vent && VP ? VP.MODEL_SHORT[VP.modelOf(vent.model)] : modelName;
    // Can they breathe for themselves? Not in arrest, not paralysed, and not set (or, by the lung
    // profile, assumed) to be sedated and not breathing on the ventilator. The profile alone only
    // counts with a tube in or in a ventilator scenario: an awake asthmatic is not sedated.
    var cfg = VE ? VE.configFor(s) : {
      breathing: null,
      profile: 'normal'
    };
    var sedatedLungs = !!(VP && VP.profiles[cfg.profile] && VP.profiles[cfg.profile].sedated);
    var cannotBreathe = arrest || paralysed || cfg.breathing === false || cfg.breathing === null && sedatedLungs && (!!tube || !!(s.scenario && s.scenario.ventSim));
    // With a tube in, the obs RR is the ventilation rate, so it says nothing about their own breathing.
    var apnoeic = cannotBreathe || !supported && !tube && rr !== null && rr <= 0;

    // The headline: the one thing the facilitator most needs to know.
    var headline, tone;
    var airwayWord = tube === 'sga' ? 'Supraglottic airway' : tube === 'fona' ? 'Front-of-neck airway' : 'Intubated';
    if (arrest) {
      headline = "In cardiac arrest: ".concat(RG.labelFor(rhythm));
      tone = 'red';
    } else if (tube && !supported && vent && apnoeic) {
      headline = "".concat(airwayWord, " but NOT being ventilated (the ").concat(ventName, " is ").concat(ventWhy, ")");
      tone = 'red';
    } else if (tube && !supported && vent) {
      headline = "".concat(airwayWord, ", breathing for themselves (the ").concat(ventName, " is ").concat(ventWhy, ")");
      tone = 'amber';
    } else if (tube && !supported) {
      headline = "".concat(airwayWord, ": ventilation assumed (no ventilator linked)");
      tone = 'cyan';
    } else if (apnoeic && !supported) {
      headline = (paralysed ? 'Paralysed and apnoeic: NOT being ventilated' : 'Apnoeic: NOT being ventilated') + (vent && (manual || highFlow) && reaches ? " (the ".concat(ventName, " is ").concat(ventWhy, ")") : '');
      tone = 'red';
    } else if (ventilating && manual && !apnoeic) {
      headline = "".concat(tube ? airwayWord + ', b' : 'B', "reathing for themselves on the ").concat(ventName, " in Man/Spon");
      tone = 'cyan';
    } else if (ventilating) {
      var how = tube === 'sga' ? 'on a supraglottic airway' : tube === 'fona' ? 'with a front-of-neck airway' : tube ? 'intubated' : 'on a mask';
      headline = "".concat(apnoeic ? 'Anaesthetised, ' + how : how.charAt(0).toUpperCase() + how.slice(1), " and ventilated on the ").concat(ventName).concat(vent.label ? " (".concat(vent.label, ")") : '');
      tone = 'cyan';
    } else if (bagging) {
      headline = "Being ventilated by bag and ".concat(tube ? tube === 'sga' ? 'supraglottic airway' : 'tube' : 'mask');
      tone = 'amber';
    } else if (niv) {
      headline = "On ".concat(niv);
      tone = 'cyan';
    } else if (highFlow && reaches) {
      headline = "On high-flow oxygen on the ".concat(ventName);
      tone = 'cyan';
    } else if (manual && reaches) {
      headline = "On the ".concat(ventName, " in Man/Spon, breathing for themselves");
      tone = 'cyan';
    } else {
      headline = null; // filled from the flags below
      tone = 'green';
    }

    // The out-of-range obs.
    var flags = [];
    var flag = function flag(text, level) {
      return flags.push({
        text: text,
        level: level
      });
    };
    if (!arrest) {
      if (!supported && !tube && !apnoeic && rr !== null && rr > L.rrHi) flag("Distressed: RR ".concat(rr), 'red');else if (!supported && !tube && !apnoeic && rr !== null && rr > 0 && rr < L.rrLo) flag("Slow breathing: RR ".concat(rr), 'red');
      if (spo2 !== null && spo2 < 88) flag("Hypoxic: SpO2 ".concat(Math.round(spo2), "%"), 'red');else if (spo2 !== null && spo2 < 92) flag("Low SpO2: ".concat(Math.round(spo2), "%"), 'amber');
      if (sbp !== null && sbp < L.sbpLo) flag("Hypotensive: BP ".concat(Math.round(sbp)).concat(dbp !== null ? '/' + Math.round(dbp) : ''), 'red');
      if (hr !== null && hr > L.hrHi) flag("Tachycardic: HR ".concat(Math.round(hr)), 'amber');else if (hr !== null && hr < L.hrLo) flag("Bradycardic: HR ".concat(Math.round(hr)), 'red');
      if (gcs !== null && gcs <= 8 && !paralysed && !tube) flag("Unconscious: GCS ".concat(gcs), 'red');else if (gcs !== null && gcs < 15 && gcs > 8) flag("GCS ".concat(gcs), 'amber');
    }
    if (temp !== null && temp <= 35) flag("Hypothermic: ".concat(temp.toFixed(1), "\xB0C"), temp < 32 ? 'red' : 'amber');else if (temp !== null && temp >= 39.1) flag("Fever: ".concat(temp.toFixed(1), "\xB0C"), 'amber');
    if (bm !== null && bm < 4) flag("Hypoglycaemic: glucose ".concat(bm.toFixed(1)), 'red');
    if (s.cprInProgress) flag(has(act, 'Lucas') ? 'CPR: mechanical CPR on' : 'CPR in progress', arrest ? 'cyan' : 'red');else if (arrest) flag('No CPR running', 'red');
    if (arrest && s.arrest && Number.isFinite(s.arrest.since)) {
      var secs = Math.max(0, Math.round((Number(s.time) || 0) - s.arrest.since));
      flag("Arrest time ".concat(Math.floor(secs / 60), ":").concat(String(secs % 60).padStart(2, '0')), 'slate');
    }
    if (paralysed && !arrest) flag('Paralysed', 'slate');
    if (s.pacing && s.pacing.electrical) flag(s.pacing.mechanical ? 'Paced with capture' : 'Pacing: no capture', s.pacing.mechanical ? 'cyan' : 'red');
    // The modelled ICP, in scenarios that have one (neuro deterioration). It answers to
    // osmotherapy and to a tube with normocapnia, so the facilitator can watch it come down.
    var detType = s.scenario && s.scenario.deterioration ? String(s.scenario.deterioration.type || '').toLowerCase() : '';
    var icp = num(s.icp);
    if (/^neuro/.test(detType) && icp !== null) flag("ICP ~".concat(Math.round(icp), " mmHg (model)"), icp > 25 ? 'red' : icp > 20 ? 'amber' : 'slate');
    if (!headline) {
      // The worst obs say it best ("Distressed: RR 34 · Hypoxic: SpO2 85%").
      var red = flags.filter(function (f) {
          return f.level === 'red';
        }),
        amber = flags.filter(function (f) {
          return f.level === 'amber';
        });
      var worst = red.length ? red : amber;
      headline = worst.length ? worst.slice(0, 2).map(function (f) {
        return f.text;
      }).join(' · ') + (worst.length > 2 ? " (+".concat(worst.length - 2, " more)") : '') : 'Stable: obs within normal limits';
      tone = red.length ? 'red' : amber.length ? 'amber' : 'green';
    }

    // What is attached, in words (the figure shows the same).
    var monitors = [];
    if (sensors.ecg) monitors.push('ECG');
    if (sensors.spo2) monitors.push('SpO2');
    if (sensors.nibp) monitors.push('NIBP');
    if (sensors.temp) monitors.push('Temp');
    if (sensors.etco2) monitors.push('ETCO2');
    if (sensors.art) monitors.push('Art line');
    var access = [];
    if (has(act, 'IV Access')) access.push('IV');
    if (has(act, 'IO Access')) access.push('IO');
    if (has(act, 'CVC')) access.push('Central line');
    // Fluids running through it: an infusion, or a bolus of fluid or blood still going in (until its peak).
    var t = num(s.time) || 0;
    var fluids = (access.length > 0 || has(act, 'FluidInfusion')) && (has(act, 'FluidInfusion') || (s.activeDrugs || []).some(function (d) {
      return d && ['Fluids', 'Blood', 'Albumin'].indexOf(d.key) !== -1 && t >= Number(d.startTime) && t - Number(d.startTime) < (Number(d.peak) || 600) && !(Number(d.stopTime) >= 0);
    }));
    if (fluids) access.push('IV fluids running');
    var airway = tube === 'ett' ? 'Tracheal tube' : tube === 'fona' ? 'Front-of-neck airway' : tube === 'sga' ? 'Supraglottic airway' : niv ? "".concat(niv, " mask") : bagging ? 'Bag-valve-mask' : oxygen ? 'Oxygen mask' : adjunct ? adjunct : null;
    var other = [];
    if (has(act, 'PacingPads')) other.push('Pads');
    if (has(act, 'Catheter')) other.push('Catheter');
    if (['SeldingerDrain', 'SurgicalDrain', 'FingerThoracostomy'].some(function (k) {
      return has(act, k);
    })) other.push('Chest drain');
    if (has(act, 'Lucas')) other.push('Mechanical CPR');
    // The injuries (from the scenario's words, or the facilitator's list) and the kit on them.
    var INJ = window.Injuries;
    var injuries = INJ ? INJ.forScenario(s.scenario) : [];
    var kit = INJ ? INJ.kitPlan(injuries, function (k) {
      return has(act, k);
    }) : [];
    kit.forEach(function (k) {
      if (other.indexOf(k.name) === -1) other.push(k.name);
    });
    return {
      arrest: arrest,
      apnoeic: apnoeic,
      paralysed: paralysed,
      headline: headline,
      tone: tone,
      flags: flags,
      sensors: sensors,
      tube: tube,
      bagging: bagging,
      niv: niv,
      oxygen: oxygen,
      adjunct: adjunct,
      vent: vent,
      ventilating: ventilating,
      ventWhy: ventWhy,
      manual: manual,
      highFlow: highFlow,
      model: model,
      modelName: modelName,
      modelLabel: modelLabel,
      monitors: monitors,
      access: access,
      airway: airway,
      other: other,
      cpr: !!s.cprInProgress,
      lucas: has(act, 'Lucas'),
      pads: has(act, 'PacingPads'),
      catheter: has(act, 'Catheter'),
      drain: ['SeldingerDrain', 'SurgicalDrain', 'FingerThoracostomy'].some(function (k) {
        return has(act, k);
      }),
      iv: has(act, 'IV Access') || has(act, 'IO Access'),
      cvc: has(act, 'CVC'),
      fluids: fluids,
      cyanosed: !arrest && spo2 !== null && spo2 < 88,
      eyesClosed: arrest || paralysed || !!tube || gcs !== null && gcs <= 8,
      distressed: flags.some(function (f) {
        return /^Distressed/.test(f.text);
      }),
      sex: s.scenario && s.scenario.sex === 'Female' ? 'Female' : 'Male',
      age: age,
      injuries: injuries,
      kit: kit
    };
  }

  // ---- the patient picture ------------------------------------------------------------------
  // The patient lying on a trolley, seen from above with the head at the top (so the patient's right
  // side is on the left of the picture), with every piece of kit drawn where it really goes and its
  // cable or tubing running to the monitor, the ventilator, the defib or the drip stand.
  var PatientFigure = function PatientFigure(_ref) {
    var a = _ref.a,
      className = _ref.className;
    var tint = a.arrest ? 'ps-arrest' : a.cyanosed ? 'ps-cyan' : null;
    var ventCol = a.ventilating ? '#22d3ee' : '#f59e0b';
    var anyMon = a.sensors.ecg || a.sensors.spo2 || a.sensors.nibp || a.sensors.temp || a.sensors.etco2 || a.sensors.art;
    var label = [a.headline, a.monitors.length ? 'Monitoring: ' + a.monitors.join(', ') : 'No monitoring attached', a.access.length ? 'Access: ' + a.access.join(', ') : 'No IV access', a.airway ? 'Airway: ' + a.airway : null, a.vent ? "Ventilator: ".concat(a.modelLabel, ", ").concat(a.vent.state) : null, a.other.length ? a.other.join(', ') : null, a.injuries.length && window.Injuries ? 'Injuries: ' + a.injuries.map(window.Injuries.label).join(', ') : null].filter(Boolean).join('. ');
    var INJ = window.Injuries,
      BA = window.BodyArt;
    var pregnant = a.injuries.some(function (i) {
      return i.kind === 'pregnant';
    });
    // The body: the man, the woman, the pregnant woman, or the child (smaller the younger), from
    // the artwork in images/patient/ (data/screens/bodyart.js).
    var F = BA ? BA.frame(BA.pick(a.sex, a.age, pregnant)) : null;
    var g = INJ && F ? INJ.geometry(a.injuries, F) : null;
    var S = INJ ? INJ.Sprite : null;
    var breathing = !a.apnoeic && !a.ventilating && !a.bagging;
    var chestMoves = !a.arrest && (breathing || a.ventilating || a.bagging);
    var breathDur = a.ventilating || a.bagging ? '4.5s' : a.distressed ? '1.6s' : '3.6s';
    // where the airway leaves the patient: the mouth, or the front of the neck
    var ax = 95,
      ay = a.tube === 'fona' ? 54 : 41;
    var cable = {
      fill: 'none',
      strokeWidth: 1.1,
      strokeLinecap: 'round',
      opacity: 0.85
    };
    // Kit on the arms follows the arm (and moves to the other arm when one is missing).
    var armOK = function armOK(s, n) {
      return g && g[s].arm.cut > n;
    };
    var nibpSide = armOK('R', 2) ? 'R' : 'L',
      ivSide = armOK('R', 3) ? 'R' : 'L';
    var artSide = armOK('L', 4) ? 'L' : 'R',
      spo2Side = armOK('L', 4) ? 'L' : armOK('R', 4) ? 'R' : null;
    var at = function at(s, i) {
      return g[s].arm.pts[i];
    };
    var mid = function mid(p, q, t) {
      return [p[0] + (q[0] - p[0]) * t, p[1] + (q[1] - p[1]) * t];
    };
    var z = g ? g.z : 1;
    var trolley = BA ? BA.place(BA.frame(BA.pick('Male', null, false)), BA.TROLLEY) : null;
    return /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 220 250",
      role: "img",
      "aria-label": label,
      "data-testid": "patient-figure",
      className: className
    }, /*#__PURE__*/React.createElement("title", null, label), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
      id: "ps-cyan",
      colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/React.createElement("feColorMatrix", {
      type: "matrix",
      values: "0.6 0.15 0.1 0 0  0.1 0.7 0.15 0 0  0.15 0.2 0.85 0 0.06  0 0 0 1 0"
    })), /*#__PURE__*/React.createElement("filter", {
      id: "ps-arrest",
      colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/React.createElement("feColorMatrix", {
      type: "matrix",
      values: "0.42 0.36 0.14 0 0.04  0.4 0.38 0.14 0 0.04  0.4 0.36 0.2 0 0.06  0 0 0 1 0"
    }))), trolley ? /*#__PURE__*/React.createElement("image", _extends({
      href: "images/patient/body/trolley.webp"
    }, trolley, {
      preserveAspectRatio: "none"
    })) : /*#__PURE__*/React.createElement("rect", {
      x: "52",
      y: "3",
      width: "86",
      height: "244",
      rx: "12",
      fill: "#1e293b",
      stroke: "#475569",
      strokeWidth: "1.5"
    }), a.fluids && /*#__PURE__*/React.createElement("g", {
      "data-part": "drip"
    }, S ? /*#__PURE__*/React.createElement(S, {
      name: "drip",
      c: [24, 25],
      w: 28
    }) : /*#__PURE__*/React.createElement("line", {
      x1: "24",
      y1: "6",
      x2: "24",
      y2: "70",
      stroke: "#94a3b8",
      strokeWidth: "1.5"
    })), a.sensors.art && /*#__PURE__*/React.createElement("g", {
      "data-part": "artbag"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "9",
      y: "46",
      width: "11",
      height: "15",
      rx: "3",
      fill: "#fecaca",
      stroke: "#ef4444"
    }), /*#__PURE__*/React.createElement("text", {
      x: "14.5",
      y: "56",
      fontSize: "5",
      textAnchor: "middle",
      fill: "#7f1d1d",
      fontWeight: "bold"
    }, "300")), g && /*#__PURE__*/React.createElement(INJ.Body, {
      g: g,
      eyesClosed: a.eyesClosed,
      breathe: chestMoves,
      breathDur: breathDur,
      tint: tint
    }), g && /*#__PURE__*/React.createElement(INJ.InjuryLayer, {
      list: a.injuries,
      g: g
    }), g && /*#__PURE__*/React.createElement(INJ.KitLayer, {
      kit: a.kit,
      list: a.injuries,
      g: g
    }), /*#__PURE__*/React.createElement("g", {
      "data-part": "monitor",
      opacity: anyMon ? 1 : 0.45
    }, /*#__PURE__*/React.createElement("rect", {
      x: "150",
      y: "58",
      width: "66",
      height: "46",
      rx: "5",
      fill: "#0b1220",
      stroke: anyMon ? '#38bdf8' : '#475569',
      strokeWidth: "1.5"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "155",
      y: "63",
      width: "56",
      height: "30",
      rx: "2",
      fill: "#020617"
    }), a.sensors.ecg && /*#__PURE__*/React.createElement("path", {
      d: "M157 74 h8 l2 -5 l2 9 l2 -4 h9 l2 -5 l2 9 l2 -4 h9 l2 -5 l2 9 l2 -4 h3",
      stroke: "#4ade80",
      strokeWidth: "1",
      fill: "none"
    }), a.sensors.spo2 && /*#__PURE__*/React.createElement("path", {
      d: "M157 86 q4 -6 8 0 t8 0 t8 0 t8 0 t8 0 t5 0",
      stroke: "#38bdf8",
      strokeWidth: "0.9",
      fill: "none"
    }), !anyMon && /*#__PURE__*/React.createElement("text", {
      x: "183",
      y: "81",
      fontSize: "6",
      textAnchor: "middle",
      fill: "#94a3b8"
    }, "no sensors"), /*#__PURE__*/React.createElement("text", {
      x: "183",
      y: "100.5",
      fontSize: "5.5",
      textAnchor: "middle",
      fill: "#94a3b8",
      fontWeight: "bold"
    }, "MONITOR")), a.vent && !a.bagging && /*#__PURE__*/React.createElement("g", {
      "data-part": "vent"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "150",
      y: "6",
      width: "66",
      height: "44",
      rx: "5",
      fill: "#0b1220",
      stroke: ventCol,
      strokeWidth: "1.8"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "155",
      y: "11",
      width: "56",
      height: "22",
      rx: "2",
      fill: "#020617"
    }), a.ventilating && /*#__PURE__*/React.createElement("path", {
      d: "M157 28 l4 -12 h10 l3 12 h4 l4 -12 h10 l3 12 h4 l4 -12 h4",
      stroke: ventCol,
      strokeWidth: "1",
      fill: "none"
    }), !a.ventilating && /*#__PURE__*/React.createElement("text", {
      x: "183",
      y: "25",
      fontSize: "7",
      textAnchor: "middle",
      fill: ventCol,
      fontWeight: "bold"
    }, a.vent.state === 'ventilating' ? a.highFlow ? 'HFO' : a.manual ? 'MAN' : 'no link' : a.vent.state), /*#__PURE__*/React.createElement("text", {
      x: "183",
      y: "44",
      fontSize: "7.5",
      textAnchor: "middle",
      fill: ventCol,
      fontWeight: "bold"
    }, a.model === 'a350' ? 'ANAESTHETIC' : a.model === 'c6' ? 'ICU' : 'TRANSPORT')), a.pads && /*#__PURE__*/React.createElement("g", {
      "data-part": "defib"
    }, /*#__PURE__*/React.createElement("rect", {
      x: "150",
      y: "112",
      width: "66",
      height: "34",
      rx: "5",
      fill: "#1c1917",
      stroke: "#f97316",
      strokeWidth: "1.5"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "155",
      y: "117",
      width: "34",
      height: "18",
      rx: "2",
      fill: "#020617"
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "203",
      cy: "126",
      r: "7",
      fill: "#dc2626",
      stroke: "#fecaca",
      strokeWidth: "0.8"
    }), /*#__PURE__*/React.createElement("text", {
      x: "203",
      y: "128",
      fontSize: "5",
      textAnchor: "middle",
      fill: "#fff",
      fontWeight: "bold"
    }, "\u26A1"), /*#__PURE__*/React.createElement("text", {
      x: "172",
      y: "142",
      fontSize: "5.5",
      textAnchor: "middle",
      fill: "#fdba74",
      fontWeight: "bold"
    }, "DEFIB")), g && a.sensors.nibp && function () {
      var p = at(nibpSide, 1);
      return /*#__PURE__*/React.createElement("g", {
        "data-part": "nibp"
      }, /*#__PURE__*/React.createElement("path", _extends({
        d: "M".concat(p[0], " ").concat(p[1] - 4, " C").concat(p[0] - 14, " ").concat(p[1] - 8, " 44 10 60 6 C80 1 120 1 136 6 C148 12 146 50 152 60"),
        stroke: "#64748b"
      }, cable, {
        strokeWidth: "1.6"
      })), /*#__PURE__*/React.createElement(S, {
        name: "cuff",
        c: p,
        w: 12 * z,
        h: 15 * z,
        rot: nibpSide === 'R' ? 8 : -8
      }));
    }(), g && a.iv && function () {
      var p = at(ivSide, 3);
      return /*#__PURE__*/React.createElement("g", {
        "data-part": "iv"
      }, a.fluids && /*#__PURE__*/React.createElement("path", _extends({
        "data-part": "giving-set",
        d: "M20 44 C22 80 ".concat(p[0] - 14, " ").concat(p[1] - 6, " ").concat(p[0], " ").concat(p[1]),
        stroke: "#7dd3fc"
      }, cable)), /*#__PURE__*/React.createElement(S, {
        name: "cannula",
        c: p,
        w: 11 * z,
        rot: -70
      }));
    }(), g && a.sensors.art && function () {
      var p = mid(at(artSide, 3), at(artSide, 4), 0.8);
      return /*#__PURE__*/React.createElement("g", {
        "data-part": "art"
      }, /*#__PURE__*/React.createElement("path", _extends({
        d: "M".concat(p[0], " ").concat(p[1], " C150 150 30 170 14 61"),
        stroke: "#ef4444"
      }, cable, {
        opacity: "0.7"
      })), /*#__PURE__*/React.createElement(S, {
        name: "cannula",
        c: p,
        w: 9 * z,
        rot: -110
      }), /*#__PURE__*/React.createElement("circle", {
        cx: p[0],
        cy: p[1],
        r: 1.6 * z,
        fill: "#dc2626"
      }));
    }(), g && a.sensors.spo2 && function () {
      var p = spo2Side ? mid(at(spo2Side, 4), at(spo2Side, 5), 0.78) : g.T([110.5, 31]);
      return /*#__PURE__*/React.createElement("g", {
        "data-part": "spo2"
      }, /*#__PURE__*/React.createElement("path", _extends({
        d: "M".concat(p[0], " ").concat(p[1], " C140 140 140 110 150 92"),
        stroke: "#94a3b8"
      }, cable)), /*#__PURE__*/React.createElement(S, {
        name: "spo2",
        c: p,
        w: 11 * z,
        rot: spo2Side === 'R' ? 100 : 80
      }), /*#__PURE__*/React.createElement("circle", {
        cx: p[0],
        cy: p[1],
        r: 1.2 * z,
        fill: "#fecaca"
      }, /*#__PURE__*/React.createElement("animate", {
        attributeName: "opacity",
        values: "1;0.3;1",
        dur: "0.9s",
        repeatCount: "indefinite"
      })));
    }(), /*#__PURE__*/React.createElement("g", {
      transform: F ? F.matrix : undefined
    }, a.lucas && /*#__PURE__*/React.createElement("g", {
      "data-part": "lucas"
    }, S && /*#__PURE__*/React.createElement(S, {
      name: "lucas",
      c: [95, 82],
      w: 60
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "95",
      cy: "86",
      r: "4",
      fill: "#38bdf8",
      fillOpacity: "0.5"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "r",
      values: "4.5;3;4.5",
      dur: "0.55s",
      repeatCount: "indefinite"
    }))), a.cpr && !a.lucas && /*#__PURE__*/React.createElement("g", {
      "data-part": "cpr"
    }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
      attributeName: "transform",
      type: "translate",
      values: "0 0;0 3;0 0",
      dur: "0.55s",
      repeatCount: "indefinite"
    }), S && /*#__PURE__*/React.createElement(S, {
      name: "cprhands",
      c: [95, 86],
      w: 17
    }))), a.sensors.ecg && /*#__PURE__*/React.createElement("g", {
      "data-part": "ecg"
    }, /*#__PURE__*/React.createElement("path", _extends({
      d: "M77 66 C100 52 130 60 150 70 M113 66 C125 62 138 64 150 72 M112 112 C130 104 140 90 150 76",
      stroke: "#e2e8f0"
    }, cable)), [[77, 66, '#ef4444'], [113, 66, '#facc15'], [112, 112, '#22c55e']].map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 3),
        x = _ref3[0],
        y = _ref3[1],
        c = _ref3[2];
      return /*#__PURE__*/React.createElement("g", {
        key: c
      }, S && /*#__PURE__*/React.createElement(S, {
        name: "electrode",
        c: [x, y],
        w: 8
      }), /*#__PURE__*/React.createElement("circle", {
        cx: x,
        cy: y,
        r: "1.3",
        fill: c
      }));
    })), a.pads && /*#__PURE__*/React.createElement("g", {
      "data-part": "pads"
    }, /*#__PURE__*/React.createElement("path", _extends({
      d: "M84 70 C110 48 140 110 150 122 M124 98 C134 104 142 116 150 128",
      stroke: "#f97316"
    }, cable, {
      strokeWidth: "1.4"
    })), [[80, 75, -12], [120, 99, 10]].map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 3),
        x = _ref5[0],
        y = _ref5[1],
        r = _ref5[2];
      return /*#__PURE__*/React.createElement("g", {
        key: x,
        transform: "rotate(".concat(r, " ").concat(x, " ").concat(y, ")")
      }, /*#__PURE__*/React.createElement("rect", {
        x: x - 7.5,
        y: y - 9.5,
        width: "15",
        height: "19",
        rx: "3",
        fill: "#f8fafc",
        stroke: "#94a3b8",
        strokeWidth: "0.8"
      }), /*#__PURE__*/React.createElement("rect", {
        x: x - 5.5,
        y: y - 7.5,
        width: "11",
        height: "15",
        rx: "2",
        fill: "#e2e8f0",
        stroke: "#cbd5e1",
        strokeWidth: "0.5"
      }), /*#__PURE__*/React.createElement("rect", {
        x: x - 2,
        y: y - 11,
        width: "4",
        height: "3",
        rx: "1",
        fill: "#f97316"
      }));
    })), a.sensors.temp && /*#__PURE__*/React.createElement("g", {
      "data-part": "temp"
    }, /*#__PURE__*/React.createElement("path", _extends({
      d: "M111 31 C126 30 138 50 150 62",
      stroke: "#fb923c"
    }, cable)), /*#__PURE__*/React.createElement("circle", {
      cx: "110.5",
      cy: "31",
      r: "2",
      fill: "#fb923c"
    })), a.cvc && /*#__PURE__*/React.createElement("g", {
      "data-part": "cvc"
    }, S && /*#__PURE__*/React.createElement(S, {
      name: "cvc",
      c: [86, 54],
      w: 11,
      rot: -25
    })), a.drain && /*#__PURE__*/React.createElement("g", {
      "data-part": "drain"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M121 92 C140 100 136 150 142 166",
      stroke: "#cbd5e1",
      strokeWidth: "1.6",
      fill: "none"
    }), S && /*#__PURE__*/React.createElement(S, {
      name: "drain",
      c: [145, 178],
      w: 18
    }), /*#__PURE__*/React.createElement("circle", {
      cx: "121",
      cy: "92",
      r: "1.6",
      fill: "#f8fafc"
    })), a.catheter && /*#__PURE__*/React.createElement("g", {
      "data-part": "catheter"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M95 136 C96 160 60 170 46 176",
      stroke: "#fde047",
      strokeWidth: "1.3",
      fill: "none"
    }), S && /*#__PURE__*/React.createElement(S, {
      name: "catheter",
      c: [36, 184],
      w: 22
    })), a.adjunct === 'OPA' && !a.tube && !a.niv && !a.oxygen && !a.bagging && /*#__PURE__*/React.createElement("g", {
      "data-part": "opa"
    }, S && /*#__PURE__*/React.createElement(S, {
      name: "guedel",
      c: [95, 40],
      w: 6
    })), (a.niv || a.oxygen) && !a.tube && !a.bagging && /*#__PURE__*/React.createElement("g", {
      "data-part": "mask"
    }, a.niv ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
      d: "M80 31 Q78 24 81 22 M110 31 Q112 24 109 22",
      stroke: "#64748b",
      strokeWidth: "2",
      fill: "none"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M86 26 Q95 20 104 26 L105 41 Q95 49 85 41 Z",
      fill: "#bae6fd",
      fillOpacity: "0.55",
      stroke: "#38bdf8",
      strokeWidth: "1.2"
    })) : /*#__PURE__*/React.createElement(React.Fragment, null, S && /*#__PURE__*/React.createElement(S, {
      name: "mask",
      c: [100, 40],
      w: 27
    }), /*#__PURE__*/React.createElement("path", _extends({
      d: "M106 46 C120 42 120 10 150 4",
      stroke: "#22c55e"
    }, cable)))), a.bagging && !a.tube && /*#__PURE__*/React.createElement("g", {
      "data-part": "mask"
    }, /*#__PURE__*/React.createElement("ellipse", {
      cx: "95",
      cy: "37",
      rx: "8",
      ry: "7",
      fill: "#f1f5f9",
      fillOpacity: "0.25",
      stroke: "#94a3b8",
      strokeWidth: "1"
    })), a.tube && /*#__PURE__*/React.createElement("g", {
      "data-part": "tube"
    }, a.tube !== 'fona' && /*#__PURE__*/React.createElement("path", {
      d: "M82 38 Q95 44 108 38",
      stroke: "#f8fafc",
      strokeWidth: "1.2",
      fill: "none",
      opacity: "0.8"
    }), S && (a.tube === 'sga' ? /*#__PURE__*/React.createElement(S, {
      name: "igel",
      c: [ax + 2, ay - 2],
      w: 10,
      rot: -30
    }) : /*#__PURE__*/React.createElement(S, {
      name: "tube",
      c: [ax + 3, ay - 4],
      w: 10,
      rot: -20
    }))), (a.tube || a.niv || a.vent && a.ventilating) && a.vent && !a.bagging && /*#__PURE__*/React.createElement("path", {
      "data-part": "circuit",
      d: "M".concat(ax + 8, " ").concat(a.tube ? ay - 10 : 36, " C").concat(ax + 30, " ").concat(a.tube ? ay - 16 : 30, " ").concat(ax + 40, " 30 150 28"),
      stroke: "#cbd5e1",
      strokeWidth: "4",
      strokeDasharray: "1.6 1.2",
      fill: "none",
      opacity: "0.9"
    }), a.bagging && /*#__PURE__*/React.createElement("g", {
      "data-part": "bag"
    }, S && (a.tube ? /*#__PURE__*/React.createElement(S, {
      name: "bvm",
      c: [121, 26],
      w: 38,
      rot: -25,
      flip: true
    }) : /*#__PURE__*/React.createElement(S, {
      name: "bvm",
      c: [113, 32],
      w: 44,
      rot: -10,
      flip: true
    }))), a.sensors.etco2 && /*#__PURE__*/React.createElement("g", {
      "data-part": "etco2"
    }, /*#__PURE__*/React.createElement("path", _extends({
      d: "M".concat(a.tube ? ax + 14 : 104, " ").concat(a.tube ? ay - 5 : 40, " C130 50 140 56 150 66"),
      stroke: "#facc15"
    }, cable)), /*#__PURE__*/React.createElement("rect", {
      x: a.tube ? ax + 9 : 99,
      y: a.tube ? ay - 11 : 34,
      width: "12",
      height: "7",
      rx: "1.5",
      fill: "#facc15",
      stroke: "#854d0e",
      strokeWidth: "0.5"
    }), /*#__PURE__*/React.createElement("text", {
      x: a.tube ? ax + 15 : 105,
      y: a.tube ? ay - 6 : 39,
      fontSize: "4.5",
      textAnchor: "middle",
      fill: "#000",
      fontWeight: "bold"
    }, "CO2"))));
  };
  var TONE = {
    red: 'border-red-500 bg-red-950/50 text-red-200',
    amber: 'border-amber-500 bg-amber-950/40 text-amber-200',
    cyan: 'border-cyan-500 bg-cyan-950/40 text-cyan-200',
    green: 'border-emerald-600 bg-emerald-950/30 text-emerald-200',
    slate: 'border-slate-600 bg-slate-800 text-slate-200'
  };
  var CHIP = {
    red: 'bg-red-700 text-white',
    amber: 'bg-amber-500 text-black',
    cyan: 'bg-cyan-700 text-white',
    green: 'bg-emerald-700 text-white',
    slate: 'bg-slate-700 text-slate-100'
  };

  // ---- the picture on the patient monitor --------------------------------------------------
  // "Show on monitor" puts the picture on every patient screen that has a monitor, for the team to
  // see (a handover, or a guide to the moulage). It rides in monitorPopup like a result, so the
  // database rules are unchanged: the injuries, sex and age go with it, and the monitor draws the
  // kit, colour and breathing from its own synced state, so they stay live. A result sent later
  // replaces it, as one result replaces another.
  var PICTURE = 'Patient picture';
  var pictureOf = function pictureOf(state) {
    var INJ = window.Injuries,
      sc = state.scenario || {};
    var injuries = INJ ? INJ.forScenario(sc).map(function (i) {
      return {
        region: i.region,
        kind: i.kind,
        side: i.side || null,
        open: !!i.open
      };
    }) : [];
    return {
      injuries: injuries,
      sex: sc.sex === 'Female' ? 'Female' : 'Male',
      age: num(sc.patientAge)
    };
  };
  var pictureShown = function pictureShown(state) {
    return !!(state.monitorPopup && state.monitorPopup.type === PICTURE && state.monitorPopup.picture);
  };
  var usePictureOnMonitor = function usePictureOnMonitor(sim, log) {
    var state = sim.state;
    var shown = pictureShown(state);
    var now = JSON.stringify(pictureOf(state));
    // Keep the monitor's copy up to date while it is showing (an injury added, a different patient).
    React.useEffect(function () {
      if (shown && JSON.stringify(state.monitorPopup.picture) !== now) sim.dispatch({
        type: 'TRIGGER_POPUP',
        payload: {
          type: PICTURE,
          picture: JSON.parse(now)
        }
      });
    }, [shown, now]);
    var toggle = function toggle() {
      if (shown) {
        sim.dispatch({
          type: 'CLEAR_POPUP'
        });
        log('Patient picture taken off the monitor (facilitator)', 'system');
      } else {
        sim.dispatch({
          type: 'TRIGGER_POPUP',
          payload: {
            type: PICTURE,
            picture: JSON.parse(now)
          }
        });
        log('Patient picture shown on the monitor (facilitator)', 'system');
      }
    };
    return {
      shown: shown,
      toggle: toggle
    };
  };
  var PictureButton = function PictureButton(_ref6) {
    var pic = _ref6.pic,
      _ref6$className = _ref6.className,
      className = _ref6$className === void 0 ? '' : _ref6$className;
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: pic.toggle,
      "aria-pressed": pic.shown,
      "data-testid": "picture-on-monitor",
      title: pic.shown ? 'Take the patient picture off the patient monitor' : 'Show this picture on the patient monitor, for the team to see',
      className: "flex-none text-[10px] uppercase font-bold px-2 py-0.5 rounded border ".concat(pic.shown ? 'bg-sky-900/50 border-sky-400 text-sky-100' : 'border-sky-600 text-sky-300 hover:bg-sky-900/40', " ").concat(className)
    }, pic.shown ? 'Hide from monitor' : 'Show on monitor');
  };
  // The monitor's side (data/screens/monitor.js MonitorContainer): the picture over the whole screen.
  var MonitorPicture = function MonitorPicture(_ref7) {
    var state = _ref7.state;
    if (!pictureShown(state)) return null;
    var p = state.monitorPopup.picture;
    var injuries = Array.isArray(p.injuries) ? p.injuries : Object.values(p.injuries || {});
    var a = assess(_objectSpread(_objectSpread({}, state), {}, {
      scenario: _objectSpread(_objectSpread({}, state.scenario || {}), {}, {
        sex: p.sex,
        patientAge: p.age,
        injuries: injuries
      })
    }));
    return /*#__PURE__*/React.createElement("div", {
      className: "absolute inset-0 z-[80] bg-slate-950 flex flex-col items-center justify-center p-3 animate-fadeIn",
      "data-testid": "monitor-picture"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-slate-300 text-sm md:text-lg font-bold uppercase tracking-widest mb-2"
    }, "The patient"), /*#__PURE__*/React.createElement(PatientFigure, {
      a: a,
      className: "h-[82vh] max-w-full"
    }));
  };

  // ---- setting the patient up before START -------------------------------------------------
  // Injuries and the kit already on the patient when the team arrives (tourniquets, a cannula, an
  // oxygen mask ...), in any mode. Kit put on here is not the team's action and does not change the
  // obs (sim.setUpIntervention, data/engine.js); the team can still take it off.
  var SETUP_KIT = [['Obs', 'Monitoring'], ['IV Access', 'IV cannula'], ['Oxygen', 'Oxygen mask'], ['OPA', 'Guedel airway'], ['NPA', 'Nasal airway'], ['FluidInfusion', 'IV fluids running'], ['Collar', 'Collar'], ['HeadBlocks', 'Head blocks'], ['Scoop', 'Scoop stretcher'], ['PelvicBinder', 'Pelvic binder'], ['Tourniquet', 'Tourniquet'], ['WoundDressing', 'Dressings'], ['ChestSeal', 'Chest seal'], ['TractionSplint', 'Traction splint'], ['Splinting', 'Splint'], ['Plaster', 'Backslab'], ['ClingFilm', 'Cling film'], ['Catheter', 'Urinary catheter'], ['ArtLine', 'Arterial line'], ['CVC', 'Central line']];
  var kitOn = function kitOn(state, key) {
    return key === 'Obs' ? !!(window.getSensors && window.getSensors(state).standard) || has(state.activeInterventions, 'Obs') : has(state.activeInterventions, key);
  };
  var PatientSetup = function PatientSetup(_ref8) {
    var sim = _ref8.sim,
      addLogEntry = _ref8.addLogEntry,
      onClose = _ref8.onClose;
    var _window = window,
      Modal = _window.Modal,
      Button = _window.Button,
      Lucide = _window.Lucide;
    var INJ = window.Injuries,
      state = sim.state;
    var log = addLogEntry || sim.addLogEntry;
    var pic = usePictureOnMonitor(sim, log);
    if (!state.scenario) return null;
    var a = assess(state);
    var setInjuries = function setInjuries(next) {
      var sc = _objectSpread({}, state.scenario);
      if (next) sc.injuries = next;else delete sc.injuries;
      sim.dispatch({
        type: 'UPDATE_SCENARIO',
        payload: sc
      });
      var now = INJ ? INJ.forScenario(sc).map(INJ.label) : [];
      log("Set-up: injuries ".concat(now.length ? now.join(', ') : 'none'), 'system');
    };
    var kit = function kit(key) {
      return sim.setUpIntervention ? sim.setUpIntervention(key) : sim.applyIntervention(key);
    };
    return /*#__PURE__*/React.createElement(Modal, {
      fixed: true,
      label: "Set up the patient",
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-4 rounded-lg border border-slate-600 w-full max-w-4xl shadow-2xl max-h-[92vh] overflow-y-auto",
      "data-testid": "patient-setup"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-start mb-3 gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Set up the patient"), /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400"
    }, "Injuries, and what is already done when the team arrives. Kit put on here does not change the obs and is not marked as the team\u2019s; they can still take it off.")), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close",
      onClick: onClose,
      className: "text-slate-400 hover:text-white flex-none"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col md:flex-row gap-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-none flex flex-col items-center gap-2"
    }, /*#__PURE__*/React.createElement(PatientFigure, {
      a: a,
      className: "w-56 h-64 bg-slate-950/70 rounded-lg"
    }), /*#__PURE__*/React.createElement(PictureButton, {
      pic: pic,
      className: "text-xs px-3 py-1"
    })), /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 flex-1 flex flex-col"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-xs font-bold uppercase text-slate-300 mb-1"
    }, "Injuries"), INJ && /*#__PURE__*/React.createElement(INJ.InjuryPicker, {
      scenario: state.scenario,
      onChange: setInjuries
    })), /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 md:w-64 flex-none"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-xs font-bold uppercase text-slate-300 mb-1"
    }, "Already done"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-1.5",
      role: "group",
      "aria-label": "Already done when the team arrives"
    }, SETUP_KIT.map(function (_ref9) {
      var _ref0 = _slicedToArray(_ref9, 2),
        key = _ref0[0],
        name = _ref0[1];
      var on = kitOn(state, key);
      return /*#__PURE__*/React.createElement("button", {
        key: key,
        type: "button",
        onClick: function onClick() {
          return kit(key);
        },
        "aria-pressed": on,
        "data-kit": key,
        className: "px-2 py-1.5 rounded border text-xs font-bold text-left ".concat(on ? 'bg-emerald-800/60 border-emerald-400 text-white' : 'bg-slate-900 border-slate-600 text-slate-300 hover:border-emerald-500')
      }, on ? "\u2713 " : '', name);
    })))), /*#__PURE__*/React.createElement("div", {
      className: "border-t border-slate-700 pt-3 mt-3 flex justify-end gap-2"
    }, Array.isArray(state.scenario.injuries) && /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setInjuries(null);
      },
      variant: "secondary"
    }, "Scenario's own injuries"), /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "primary",
      className: "px-6"
    }, "Done"))));
  };

  // ---- the strip ------------------------------------------------------------------------------
  // `showScenario`: the scenario's summary and its "Full scenario" window (data/screens/scenarioview.js),
  // for library and course scenarios (not Quick Sim, which has no scenario).
  // `setUp`: a "Set up patient" button here until START (where the page has none of its own).
  var PatientStatusPanel = function PatientStatusPanel(_ref1) {
    var sim = _ref1.sim,
      addLogEntry = _ref1.addLogEntry,
      _ref1$showVent = _ref1.showVent,
      showVent = _ref1$showVent === void 0 ? true : _ref1$showVent,
      _ref1$extra = _ref1.extra,
      extra = _ref1$extra === void 0 ? null : _ref1$extra,
      _ref1$showScenario = _ref1.showScenario,
      showScenario = _ref1$showScenario === void 0 ? false : _ref1$showScenario,
      _ref1$setUp = _ref1.setUp,
      setUp = _ref1$setUp === void 0 ? false : _ref1$setUp;
    var state = sim.state;
    var a = assess(state);
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showFull = _useState2[0],
      setShowFull = _useState2[1];
    var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      editInjuries = _useState4[0],
      setEditInjuries = _useState4[1];
    var SV = window.ScenarioView,
      INJ = window.Injuries;
    var withScenario = showScenario && !!SV && !!state.scenario;
    var VP = window.VENT_PROFILES;
    // Compact (headline, flags and a one-line summary) or full (with the figure). With no saved choice,
    // a short screen (or a narrow one, such as a portrait tablet) starts compact so the obs and resus
    // controls below keep their room.
    var _useState5 = useState(function () {
        var saved = null;
        try {
          saved = localStorage.getItem('wmebem_status_collapsed');
        } catch (e) {}
        return saved === '1' || saved === '0' ? saved === '1' : (window.innerHeight || 1000) < 900 || (window.innerWidth || 1440) < 1024;
      }),
      _useState6 = _slicedToArray(_useState5, 2),
      collapsed = _useState6[0],
      setCollapsed = _useState6[1];
    // The ventilator chooser only where a ventilator is in play: a ventilator or anaesthetic scenario,
    // one chosen in the Ventilator section, or a ventilator tablet already linked.
    var ventInPlay = !!(state.vent || state.scenario && state.scenario.ventSim || Object.keys(state.ventMirror || {}).length);
    var toggle = function toggle() {
      var n = !collapsed;
      setCollapsed(n);
      try {
        localStorage.setItem('wmebem_status_collapsed', n ? '1' : '0');
      } catch (e) {}
    };
    var log = addLogEntry || sim.addLogEntry;
    var pic = usePictureOnMonitor(sim, log);
    var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showSetup = _useState8[0],
      setShowSetup = _useState8[1];
    var notStarted = !state.isRunning && !state.isFinished && (state.pausedAt === null || state.pausedAt === undefined);
    var model = a.model;
    var ventShown = !!state.ventPanelOpen;
    var setModel = function setModel(m) {
      if (!VP || m === model) return;
      // A different machine starts switched off, so ask before taking the patient off a working one.
      if (a.vent && a.vent.state === 'ventilating' && !window.confirm("Change to the ".concat(VP.MODEL_SHORT[m], "? The tablet reloads on the new machine switched off, so the patient stops being ventilated."))) return;
      sim.dispatch({
        type: 'SET_VENT_CONFIG',
        payload: {
          model: m
        }
      });
      log("Ventilator changed to the ".concat(VP.MODEL_SHORT[m], " (facilitator)"), 'system');
    };
    // The facilitator's own injury list (null: back to what the scenario's words say).
    var setInjuries = function setInjuries(next) {
      var sc = _objectSpread({}, state.scenario);
      if (next) sc.injuries = next;else delete sc.injuries;
      sim.dispatch({
        type: 'UPDATE_SCENARIO',
        payload: sc
      });
      var now = INJ ? INJ.forScenario(sc).map(INJ.label) : [];
      log("Injuries on the patient picture: ".concat(now.length ? now.join(', ') : 'none').concat(next ? '' : " (the scenario\u2019s own)"), 'system');
    };
    var toggleVentShown = function toggleVentShown() {
      sim.dispatch({
        type: 'SET_VENT_PANEL',
        payload: !ventShown
      });
      log(ventShown ? 'Ventilator taken off the patient screens (facilitator)' : 'Ventilator shown on the patient screens (facilitator)', 'system');
    };
    // ONE-TAP RESUS during a pulseless rhythm, beside the CPR flag: the same actions as the
    // CPR button on the controller's defib panel (sim.toggleCPR, which logs "CPR started
    // (facilitator)") and its Defib button (SET_DEFIB_PANEL), so they log identically.
    var cprOn = !!state.cprInProgress;
    var defibOpen = !!state.defibPanelOpen;
    var toggleDefib = function toggleDefib() {
      sim.dispatch({
        type: 'SET_DEFIB_PANEL',
        payload: !defibOpen
      });
      // Bring the controller's own defib controls (charge, shock) into view as well.
      if (!defibOpen) setTimeout(function () {
        try {
          var el = document.querySelector('[data-testid="defib-panel"]');
          if (el) el.scrollIntoView({
            block: 'nearest',
            behavior: 'smooth'
          });
        } catch (e) {}
      }, 80);
    };
    var resusButtons = a.arrest ? /*#__PURE__*/React.createElement("span", {
      className: "inline-flex gap-1 flex-none",
      "data-testid": "status-resus"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "data-testid": "status-cpr",
      onClick: function onClick() {
        return sim.toggleCPR && sim.toggleCPR();
      },
      "aria-pressed": cprOn,
      title: cprOn ? 'Stop chest compressions (logged)' : 'Start chest compressions (logged)',
      className: "px-2 py-0.5 rounded border text-[10px] font-bold uppercase tracking-wide ".concat(cprOn ? 'bg-slate-900 border-red-400 text-red-200 hover:bg-red-950' : 'bg-red-600 border-red-300 text-white hover:bg-red-500')
    }, cprOn ? 'Stop CPR' : 'Start CPR'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      "data-testid": "status-defib",
      onClick: toggleDefib,
      "aria-pressed": defibOpen,
      title: "Opens the defibrillator on the student monitor and the controller (the same as the Defib button under Rhythm & resus).",
      className: "px-2 py-0.5 rounded border text-[10px] font-bold uppercase tracking-wide ".concat(defibOpen ? 'bg-amber-900/60 border-amber-400 text-amber-200' : 'bg-amber-500 border-amber-300 text-black hover:bg-amber-400')
    }, defibOpen ? 'Close Defib' : 'Defib')) : null;
    // The flags, with the resus buttons straight after the CPR flag ("No CPR running").
    var cprAt = a.flags.findIndex(function (f) {
      return /CPR/.test(f.text);
    });
    var flagChips = /*#__PURE__*/React.createElement(React.Fragment, null, a.flags.map(function (f, i) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: i
      }, /*#__PURE__*/React.createElement("span", {
        className: "px-1.5 py-0.5 rounded text-[10px] font-bold ".concat(CHIP[f.level] || CHIP.slate, " ").concat(String(a.headline || '').includes(f.text) ? 'max-md:hidden' : '')
      }, f.text), i === cprAt && resusButtons);
    }), cprAt === -1 && resusButtons);
    var row = function row(label, items, empty) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex gap-1.5 items-baseline min-w-0"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-[9px] uppercase font-bold text-slate-400 w-[4.6rem] flex-none"
      }, label), /*#__PURE__*/React.createElement("span", {
        className: "text-[11px] truncate ".concat(items.length ? 'text-white' : 'text-slate-300 italic')
      }, items.length ? items.join(' · ') : empty));
    };
    return /*#__PURE__*/React.createElement("section", {
      "aria-label": "Patient status",
      "data-testid": "patient-status",
      className: "flex-none mb-2 rounded border-l-4 border ".concat(TONE[a.tone] || TONE.slate)
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-x-2 gap-y-1 px-2 py-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex-none w-2.5 h-2.5 rounded-full ".concat(a.tone === 'red' ? 'bg-red-500 animate-pulse' : a.tone === 'amber' ? 'bg-amber-400' : a.tone === 'cyan' ? 'bg-cyan-400' : 'bg-emerald-400'),
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 flex-1 max-md:basis-[calc(100%-1.5rem)]"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[9px] uppercase tracking-widest font-bold text-slate-400 mr-2"
    }, "Patient now"), /*#__PURE__*/React.createElement("span", {
      "data-testid": "patient-headline",
      className: "text-sm md:text-base font-bold"
    }, a.headline)), extra && /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 max-md:order-last max-md:w-full"
    }, extra), withScenario && collapsed && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setShowFull(true);
      },
      "data-testid": "open-full-scenario-compact",
      className: "flex-none text-[10px] uppercase font-bold px-2 py-0.5 rounded border border-sky-500 text-sky-200 hover:bg-sky-900/40"
    }, "Full scenario"), setUp && notStarted && state.scenario && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setShowSetup(true);
      },
      "aria-label": "Set up the patient",
      className: "flex-none text-[10px] uppercase font-bold px-2 py-0.5 rounded border border-amber-400 bg-amber-700 text-white hover:bg-amber-600"
    }, "Set up patient"), state.scenario && /*#__PURE__*/React.createElement(PictureButton, {
      pic: pic
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: toggle,
      "aria-expanded": !collapsed,
      title: collapsed ? 'Show the patient figure and details' : 'Make this strip one line',
      className: "flex-none text-[10px] uppercase font-bold px-2 py-0.5 rounded border border-slate-600 text-slate-300 hover:bg-slate-700"
    }, collapsed ? 'More' : 'Less')), collapsed && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-1 px-2 pb-1",
      "data-testid": "patient-compact"
    }, withScenario && /*#__PURE__*/React.createElement("span", {
      className: "text-[11px] font-bold text-emerald-300 uppercase truncate max-w-[18rem]",
      title: state.scenario.title
    }, state.scenario.title), flagChips, /*#__PURE__*/React.createElement("span", {
      className: "text-[11px] text-slate-300 truncate min-w-0"
    }, [a.monitors.length ? a.monitors.join(' · ') : 'Nothing attached', a.access.length ? a.access.join(' · ') : 'No access', a.airway || 'Own airway'].join('  |  '))), !collapsed && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap md:flex-nowrap gap-3 px-2 pb-2 items-start"
    }, /*#__PURE__*/React.createElement(PatientFigure, {
      a: a,
      className: "w-32 h-36 sm:w-40 sm:h-44 md:w-44 md:h-48 flex-none bg-slate-950/70 rounded-lg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 flex-1 basis-[11rem] flex flex-col gap-1 overflow-hidden"
    }, (a.flags.length > 0 || resusButtons) && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-1",
      "data-testid": "patient-flags"
    }, flagChips), row('Monitoring', a.monitors, 'Nothing attached'), row('Access', a.access, 'None'), row('Airway', a.airway ? [a.airway] : [], 'Own airway'), a.other.length > 0 && row('Also', a.other, ''), INJ && /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1.5 items-baseline min-w-0",
      "data-testid": "patient-injuries"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[9px] uppercase font-bold text-slate-400 w-[4.6rem] flex-none flex flex-col items-start gap-1"
    }, "Injuries", state.scenario && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setEditInjuries(true);
      },
      "aria-label": "Change the injuries on the patient picture",
      className: "md:hidden text-[9px] uppercase font-bold px-1.5 py-0.5 rounded border border-slate-600 text-slate-300 hover:bg-slate-700"
    }, "Change")), /*#__PURE__*/React.createElement("span", {
      className: "text-[11px] min-w-0 ".concat(a.injuries.length ? 'text-white' : 'text-slate-300 italic')
    }, a.injuries.length ? a.injuries.map(INJ.label).join(" \xB7 ") : 'None'), state.scenario && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setEditInjuries(true);
      },
      "aria-label": "Change the injuries on the patient picture",
      className: "max-md:hidden flex-none text-[9px] uppercase font-bold px-1.5 py-0.5 rounded border border-slate-600 text-slate-300 hover:bg-slate-700"
    }, "Change"))), withScenario && /*#__PURE__*/React.createElement(SV.ScenarioSummary, {
      scenario: state.scenario,
      onOpen: function onOpen() {
        return setShowFull(true);
      }
    }), VP && showVent && ventInPlay && /*#__PURE__*/React.createElement("div", {
      className: "flex-none flex flex-col gap-1 w-full sm:w-auto sm:min-w-[11rem]",
      "data-testid": "status-vent"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[9px] uppercase font-bold text-slate-400"
    }, "Ventilator"), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-1",
      role: "group",
      "aria-label": "Choose the ventilator"
    }, Object.keys(VP.MODELS).map(function (m) {
      return /*#__PURE__*/React.createElement("button", {
        key: m,
        type: "button",
        "aria-pressed": model === m,
        title: VP.MODELS[m],
        onClick: function onClick() {
          return setModel(m);
        },
        className: "px-2 py-1 rounded border text-[10px] font-bold ".concat(model === m ? 'bg-cyan-700 border-cyan-400 text-white' : 'bg-slate-900 border-slate-600 text-slate-300 hover:border-cyan-500')
      }, {
        t1: 'Transport',
        c6: 'ICU',
        a350: 'Anaesthetic'
      }[m] || m);
    })), /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] text-slate-400"
    }, a.vent ? "".concat(a.modelLabel, ": ").concat(a.ventilating ? 'ventilating' : a.vent.state === 'ventilating' ? a.ventWhy : a.vent.state) : 'Not connected'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: toggleVentShown,
      className: "px-2 py-1 rounded border text-[10px] font-bold ".concat(ventShown ? 'bg-cyan-900/40 border-cyan-500 text-cyan-200' : 'bg-slate-900 border-cyan-600/60 text-cyan-300')
    }, ventShown ? 'Take off the patient screens' : 'Show on the patient screens'))), showFull && SV && state.scenario && /*#__PURE__*/React.createElement(SV.FullScenarioModal, {
      scenario: state.scenario,
      onClose: function onClose() {
        return setShowFull(false);
      }
    }), showSetup && /*#__PURE__*/React.createElement(PatientSetup, {
      sim: sim,
      addLogEntry: log,
      onClose: function onClose() {
        return setShowSetup(false);
      }
    }), editInjuries && INJ && state.scenario && /*#__PURE__*/React.createElement(INJ.InjuryEditor, {
      scenario: state.scenario,
      onChange: setInjuries,
      onClose: function onClose() {
        return setEditInjuries(false);
      }
    }));
  };
  window.PatientStatus = {
    assess: assess,
    limitsFor: limitsFor,
    PatientFigure: PatientFigure,
    PatientStatusPanel: PatientStatusPanel,
    PatientSetup: PatientSetup,
    MonitorPicture: MonitorPicture,
    usePictureOnMonitor: usePictureOnMonitor,
    PictureButton: PictureButton
  };
})();